var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99295 1.94824V10.3074C4.79462 10.3132 4.59628 10.3599 4.45045 10.4474L3.07962 11.2291C2.12295 11.7774 1.33545 11.3224 1.33545 10.2141V4.53824C1.33545 4.17074 1.59795 3.71574 1.92462 3.52908L4.45045 2.08241C4.59628 2.00074 4.79462 1.95408 4.99295 1.94824Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17518 3.69206V12.0512C8.97101 12.0571 8.77268 12.0221 8.61518 11.9462L5.55268 10.4121C5.39518 10.3362 5.19684 10.3012 4.99268 10.3071V1.94789C5.19684 1.94206 5.39518 1.97706 5.55268 2.05289L8.61518 3.58706C8.77268 3.66289 8.97101 3.69789 9.17518 3.69206Z",
    fill: "#3694FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8338 3.78555V9.46138C12.8338 9.82888 12.5713 10.2839 12.2446 10.4705L9.71877 11.9172C9.57294 11.9989 9.3746 12.0455 9.17627 12.0514V3.69221C9.3746 3.68638 9.57294 3.63971 9.71877 3.55221L11.0896 2.77055C12.0463 2.22221 12.8338 2.67721 12.8338 3.78555Z",
    fill: "#C6E1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.94565fcf27d87878af54cde09305fa8c.svg";
export { ForwardRef as ReactComponent };